
import { defineComponent, computed } from "vue";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import CarouselType from "@/entities/carousel";
import { useImage } from "@vueuse/core";

export default defineComponent({
  name: "Autoplay",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["images"],
  setup(props) {
    const loadings = computed(() => {
      return props.images
        .filter((image: CarouselType) => image.carousel_image != null)
        .map(
          (image: { carousel_image: { image: { url: string } } }) =>
            useImage({ src: image.carousel_image?.image.url }).isLoading
        );
    });
    return {
      loadings,
      availableWrap: computed(() => props.images.length > 1),
    };
  },
  data() {
    return {
      isFirstImageLoaded: false,
    };
  },
});
